import { htmlSafe } from '@ember/template';
import { Marked } from 'marked';

// Synchronous marked instance — no async walkers, always returns string
const md = new Marked({ async: false });

/**
 * Parses a markdown string and returns an Ember SafeString of the resulting HTML.
 * Content is generated by the in-house LLM pipeline, not by end users.
 */
export default function parseMarkdown(
  text: string | null | undefined
): ReturnType<typeof htmlSafe> {
  if (!text) return htmlSafe('');
  return htmlSafe(md.parse(text) as string);
}
